import { render, staticRenderFns } from "./SimpleSelect.vue?vue&type=template&id=ded2f328&scoped=true&"
import script from "./SimpleSelect.vue?vue&type=script&lang=ts&"
export * from "./SimpleSelect.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleSelect.vue?vue&type=style&index=0&id=ded2f328&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded2f328",
  null
  
)

export default component.exports